export function apiUrl(controllerUrl) {
  const URL = process.env.REACT_APP_API_URL;

  return `${URL}/auth/` + controllerUrl;
}
